// extracted by mini-css-extract-plugin
export default {"container":"products_container__7Obcf","products":"products_products__pZ1qR","menu":"products_menu__7kGQ-","list":"products_list__7t3S3","product":"products_product__b6PKc"};